import { render, staticRenderFns } from "./AskMoveMandates.vue?vue&type=template&id=003d51d2&"
import script from "./AskMoveMandates.vue?vue&type=script&lang=js&"
export * from "./AskMoveMandates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports